// extracted by mini-css-extract-plugin
export var container = "cY_c";
export var gradientContainer = "cY_h1";
export var list = "cY_c9";
export var listWrapper = "cY_h2";